import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_READ_ONLY } = ROLES;

const ALLOWED_ROLES_VIEW_CHECKOUT_THEMES = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_READ_ONLY];

const ALLOWED_ROLES_CREATE_CHECKOUT_THEME = [ROLE_OWNER, ROLE_ADMINISTRATOR];

const ALLOWED_ROLES_EDIT_CHECKOUT_THEME = [ROLE_OWNER, ROLE_ADMINISTRATOR];

export function canViewCheckoutThemes(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_VIEW_CHECKOUT_THEMES);
}

export function canCreateCheckoutTheme(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_CREATE_CHECKOUT_THEME);
}

export function canEditCheckoutTheme(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_EDIT_CHECKOUT_THEME);
}
